import { CR_API_ENDPOINTS } from '../constants';
import { NetsuiteItemResponse } from '../types/netsuite-items.types';
import { apiService } from './api.service';

class NetsuiteItemsService {
  /**
   * Fetches all NetSuite items for a specific client.
   * @param clientId - The UUID of the client
   * @returns Array of NetSuite items
   */
  async getItemsByClient(clientId: string): Promise<NetsuiteItemResponse[]> {
    return apiService.get<NetsuiteItemResponse[]>(
      `${CR_API_ENDPOINTS.NETSUITE_ITEMS}/by-client/${clientId}`,
    );
  }

  /**
   * Fetches distinct item categories for a specific client.
   * @param clientId - The UUID of the client
   * @returns Array of category name strings
   */
  async getCategoriesByClient(clientId: string): Promise<string[]> {
    return apiService.get<string[]>(
      `${CR_API_ENDPOINTS.NETSUITE_ITEMS}/by-client/${clientId}/categories`,
    );
  }

  /**
   * Imports NetSuite items from an Excel file for a specific client.
   * @param clientId - The UUID of the client
   * @param file - The Excel (.xlsx) file to import
   * @returns Import result with count of imported items
   */
  async importExcel(clientId: string, file: File): Promise<{ inserted_count: number; updated_count: number; skipped_count: number; client_id: string }> {
    return apiService.uploadFile<{ inserted_count: number; updated_count: number; skipped_count: number; client_id: string }>(
      `${CR_API_ENDPOINTS.NETSUITE_ITEMS}/import/${clientId}`,
      file,
    );
  }
}

export const netsuiteItemsService = new NetsuiteItemsService();
